import { changeErrorVisibility, setButtonLoading, startPasskeyAutofill, usePasskeyButton, usePasskeyPageLink } from './login-common';

(() => {
  function onSubmit(e: Event) {
    const username = document.getElementById('username') as HTMLInputElement;
    if (username && !username.value) {
      changeErrorVisibility(username, 'required');
      e.preventDefault();
    } else {
      setButtonLoading(document.getElementById('submit-button') as HTMLButtonElement);
    }
  }

  function onChange(e: Event) {
    changeErrorVisibility(e.target as HTMLInputElement, false);
  }

  function onRememberMeToggle(e: Event) {
    const rememberMeNoteEl = document.getElementById('rememberMeNote') as HTMLElement;
    const checked = (e.target as HTMLInputElement).checked;
    rememberMeNoteEl.hidden = checked ? false : true;
  }

  document.getElementById('loginForm')?.addEventListener('submit', onSubmit);
  document.getElementById('username')?.addEventListener('keypress', onChange);
  document.getElementById('RememberMe')?.addEventListener('change', onRememberMeToggle);

  startPasskeyAutofill();
  usePasskeyButton();
  usePasskeyPageLink();
})();